const SlackBot = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="240"
      height="140"
      viewBox="0 0 240 140"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.607 52.3656C162.171 45.9869 141.93 42.4767 120.588 42.4767C120.39 42.4767 120.202 42.4767 120.005 42.4767C119.807 42.4767 119.619 42.4767 119.422 42.4767C98.0889 42.4767 77.838 45.9869 62.4029 52.3656C36.8188 62.9339 33 77.7202 33 85.5898C33 93.4594 36.8188 108.255 62.4029 118.823C65.0836 119.927 67.9242 120.947 70.8776 121.881V87.6563C70.8776 87.6563 64.9143 85.7219 61.6034 81.4002C63.7197 79.7112 66.993 77.6919 71.9123 75.6537C83.5286 70.8508 99.6221 67.9916 116.43 67.6897V67.718C117.616 67.6897 118.81 67.6708 119.995 67.6708C121.19 67.6708 122.375 67.6897 123.57 67.718V67.6897C140.387 67.9916 156.471 70.8602 168.088 75.6537C173.016 77.6919 176.28 79.7112 178.397 81.4002C175.086 85.7219 169.122 87.6563 169.122 87.6563V121.881C172.076 120.947 174.916 119.937 177.597 118.823C203.181 108.255 207 93.4689 207 85.5898C207 77.7107 203.181 62.9245 177.597 52.3562L177.607 52.3656Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.8771 87.647C70.8771 87.647 62.7034 85.4295 57.7559 76.1539M169.122 87.647C169.122 87.647 177.296 85.4295 182.234 76.1539"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.285 88.5339L118.095 77.8146C113.289 76.1633 110.683 70.8225 112.292 65.9346L127.116 21.0853C128.724 16.2069 133.982 13.5648 138.779 15.2161L169.969 25.9354C174.775 27.5867 177.381 32.9275 175.772 37.8153L160.949 82.6647C159.34 87.5431 154.082 90.1852 149.285 88.5339Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.006 68.2558C125.856 68.6805 125.546 69.0202 125.15 69.2089C124.755 69.407 124.304 69.4259 123.881 69.2844C123.467 69.1428 123.119 68.8409 122.921 68.4446C122.724 68.0482 122.686 67.5859 122.808 67.1613C122.874 66.9442 122.987 66.7555 123.138 66.5857C123.279 66.4158 123.457 66.2743 123.655 66.1799C123.852 66.0761 124.069 66.0195 124.285 66.0101C124.501 66.0006 124.727 66.0289 124.934 66.095C125.357 66.2365 125.705 66.5479 125.903 66.9537C126.1 67.3594 126.129 67.8312 125.988 68.2558H126.006Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M129.486 69.4448L151.854 77.1352"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.381 106.915C126.993 105.443 128.121 104.264 129.551 103.613C129.523 103.594 129.485 103.575 129.457 103.556C126.532 101.688 125.667 97.7622 127.501 94.7899C129.344 91.827 133.21 90.9306 136.135 92.8083C142.588 96.9413 149.511 96.0071 152.464 95.3183L147.959 93.5255C144.591 92.1855 142.926 88.3357 144.243 84.9104C145.56 81.4946 149.36 79.8055 152.727 81.136L169.122 87.6468C175.029 89.987 178.095 94.035 178.481 94.5729C181.472 98.97 181.989 103.641 181.989 103.641C181.989 103.641 185.648 119.295 164.701 128.703L164.475 128.807C164.4 128.844 164.325 128.873 164.25 128.91C159.471 131.09 153.066 132.789 145.645 131.619C144.253 131.402 142.973 130.713 142.014 129.665C141.055 128.618 140.471 127.269 140.368 125.844C139.202 125.674 138.054 125.438 136.916 125.146C136.85 125.127 136.794 125.108 136.728 125.089C136.126 124.881 135.486 124.598 134.922 124.211C134.884 124.183 134.856 124.164 134.818 124.136C134.63 124.004 134.452 123.853 134.282 123.702C134.254 123.674 134.217 123.645 134.188 123.617C133.37 122.834 132.777 121.852 132.467 120.758C132.157 119.663 132.138 118.503 132.42 117.408C132.514 117.04 132.646 116.7 132.787 116.37C131.959 116.115 131.141 115.823 130.341 115.502C129.739 115.238 128.761 114.766 128.009 114.171C126.033 112.416 125.281 109.51 126.363 106.925L126.381 106.915Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.014 78.0788L88.3634 87.2978C83.4912 88.7132 78.3556 85.8258 76.9541 80.8813L64.115 35.4092C62.7135 30.4647 65.5635 25.2466 70.4358 23.8312L102.087 14.6122C106.959 13.1968 112.095 16.0842 113.496 21.0287L126.335 66.5008C127.737 71.4547 124.887 76.6634 120.014 78.0788Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.144 39.6742C113.938 49.5726 108.304 59.8956 98.5499 62.7359C88.796 65.5761 78.6282 59.8484 75.8346 49.9501C73.0411 40.0517 78.6752 29.7287 88.4291 26.8885C98.1831 24.0482 108.351 29.7759 111.144 39.6742Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.144 39.6742C113.938 49.5726 108.304 59.8956 98.5499 62.7359C88.796 65.5761 78.6282 59.8484 75.8346 49.9501C73.0411 40.0517 78.6752 29.7287 88.4291 26.8885C98.1831 24.0482 108.351 29.7759 111.144 39.6742Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.5296 74.8518C89.6425 75.2858 89.5766 75.7482 89.3603 76.1351C89.1439 76.522 88.7865 76.805 88.3633 76.9277C87.94 77.0504 87.4885 77.0032 87.1029 76.7862C86.7172 76.5786 86.4256 76.22 86.294 75.786C86.2375 75.5689 86.2187 75.3425 86.2375 75.1254C86.2657 74.899 86.3316 74.6819 86.435 74.4932C86.5385 74.2951 86.689 74.1252 86.8583 73.9837C87.0276 73.8421 87.2251 73.7383 87.4415 73.6817C87.8742 73.5591 88.335 73.6062 88.7207 73.8327C89.1157 74.0497 89.3979 74.4177 89.5202 74.8612L89.5296 74.8518Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.0664 73.8232L115.763 67.218"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.4737 41.0425L84.3004 42.7127C83.2281 43.0618 82.6356 44.2224 82.9742 45.317C83.3128 46.4021 84.4509 47.006 85.5232 46.6663L90.6964 44.9867C91.7687 44.6376 92.3613 43.477 92.0227 42.3824C91.684 41.2973 90.5365 40.6934 89.4737 41.033V41.0425ZM87.837 35.7866C86.7647 36.1358 86.1722 37.2964 86.5108 38.391C86.8494 39.4761 87.9875 40.08 89.0598 39.7403L90.9974 39.1081L90.386 37.136C90.0474 36.0508 88.9093 35.4469 87.8276 35.7866H87.837Z"
        fill="#36C5F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.195 40.7123L95.5584 35.447C95.2198 34.3619 94.0817 33.758 93.0094 34.0977C91.9371 34.4468 91.3445 35.6074 91.6832 36.702L93.3198 41.9673C93.6584 43.0524 94.7965 43.6563 95.8688 43.3166C96.9411 42.9675 97.5336 41.8069 97.195 40.7123ZM102.359 39.0421C102.02 37.957 100.882 37.3531 99.8099 37.6928C98.7376 38.0419 98.145 39.2025 98.4836 40.2971L99.095 42.2692L101.033 41.637C102.105 41.2879 102.697 40.1273 102.359 39.0327V39.0421Z"
        fill="#2EB67D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.5056 48.5819L102.679 46.9023C103.751 46.5532 104.344 45.3925 104.005 44.298C103.666 43.2128 102.528 42.6089 101.456 42.9486L96.2828 44.6282C95.2106 44.9774 94.618 46.138 94.9566 47.2326C95.2952 48.3177 96.4333 48.9216 97.5056 48.5819ZM99.1516 53.8472C100.224 53.4981 100.816 52.3374 100.478 51.2429C100.139 50.1577 98.9917 49.5538 97.9289 49.8935L95.9912 50.5257L96.6026 52.4979C96.9412 53.583 98.0793 54.1869 99.1516 53.8472Z"
        fill="#ECB22E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.7825 48.9122L91.4192 54.1775C91.7578 55.2626 92.8959 55.8665 93.9682 55.5268C95.0404 55.1777 95.633 54.0171 95.2944 52.9225L93.6578 47.6572C93.3192 46.5721 92.181 45.9682 91.1088 46.3079C90.0365 46.657 89.4439 47.8176 89.7825 48.9122ZM84.6187 50.5824C84.9573 51.6675 86.1048 52.2714 87.1677 51.9317C88.24 51.5826 88.8325 50.422 88.4939 49.3274L87.8825 47.3553L85.9449 47.9875C84.8727 48.3366 84.2801 49.4972 84.6187 50.5918V50.5824Z"
        fill="#E01E5A"
      />
      <path
        d="M152.464 95.309C152.464 95.309 154.627 94.8749 157.073 93.5067M128.846 103.103C128.846 103.103 136.907 109.265 146.839 107.727M132.806 116.361C132.806 116.361 140.509 117.946 147.959 115.181M140.377 125.844C140.377 125.844 144.262 126.042 151.984 123.391"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.628 106.915C113.017 105.443 111.888 104.264 110.459 103.613C110.487 103.594 110.524 103.575 110.553 103.556C113.478 101.688 114.353 97.7622 112.509 94.7899C110.666 91.827 106.8 90.9306 103.874 92.8083C97.422 96.9413 90.4993 96.0071 87.5458 95.3183L92.0512 93.5255C95.4186 92.1855 97.0834 88.3357 95.7666 84.9104C94.4497 81.4946 90.6498 79.8055 87.2824 81.136L70.8879 87.6468C64.981 89.987 61.9147 94.035 61.5291 94.5729C58.538 98.97 58.0206 103.641 58.0206 103.641C58.0206 103.641 54.3617 119.295 75.3087 128.703L75.5345 128.807C75.6097 128.844 75.685 128.873 75.7602 128.91C80.5384 131.09 86.9438 132.789 94.3651 131.619C95.7572 131.402 97.0364 130.713 97.9958 129.665C98.9552 128.618 99.5384 127.269 99.6418 125.844C100.808 125.674 101.956 125.438 103.094 125.146C103.16 125.127 103.216 125.108 103.282 125.089C103.884 124.881 104.523 124.598 105.088 124.211C105.125 124.183 105.154 124.164 105.191 124.136C105.379 124.004 105.558 123.853 105.727 123.702C105.756 123.674 105.793 123.645 105.822 123.617C106.64 122.834 107.232 121.852 107.543 120.758C107.853 119.663 107.872 118.503 107.59 117.408C107.496 117.049 107.373 116.7 107.223 116.37C108.051 116.115 108.869 115.823 109.669 115.502C110.28 115.238 111.249 114.766 112.001 114.171C113.976 112.416 114.719 109.51 113.647 106.925L113.628 106.915Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.5444 95.309C87.5444 95.309 85.3811 94.8749 82.9355 93.5067M111.153 103.103C111.153 103.103 103.092 109.265 93.1598 107.727M107.193 116.361C107.193 116.361 99.49 117.946 92.0405 115.181M99.631 125.844C99.631 125.844 95.7464 126.042 88.0241 123.391"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.678 28.3779C172.499 22.5553 170.167 16.6361 165.468 15.1571C160.769 13.6781 155.484 17.1993 153.663 23.0219C151.842 28.8445 154.174 34.7637 158.873 36.2427C163.572 37.7217 168.857 34.2005 170.678 28.3779Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M161.723 25.5134C162.584 22.7588 161.479 19.9578 159.253 19.2573C157.028 18.5568 154.525 20.222 153.664 22.9767C152.802 25.7314 153.908 28.5323 156.133 29.2329C158.359 29.9334 160.861 28.2681 161.723 25.5134Z"
        fill="#212121"
      />
      <path
        d="M153.909 22.8988C155.73 17.0762 153.397 11.157 148.698 9.67801C144 8.19899 138.714 11.7202 136.893 17.5428C135.072 23.3654 137.405 29.2846 142.104 30.7636C146.802 32.2426 152.088 28.7214 153.909 22.8988Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M144.963 20.0248C145.824 17.2701 144.719 14.4691 142.493 13.7686C140.268 13.0681 137.765 14.7334 136.904 17.488C136.042 20.2427 137.148 23.0437 139.373 23.7442C141.599 24.4447 144.101 22.7795 144.963 20.0248Z"
        fill="#212121"
      />
      <path
        d="M168.21 39.0987C167.495 37.2775 166.009 35.7866 164.015 35.1356C160.469 33.9749 156.659 35.9376 155.512 39.5233"
        fill="white"
      />
      <path
        d="M168.21 39.0987C167.495 37.2775 166.009 35.7866 164.015 35.1356C160.469 33.9749 156.659 35.9376 155.512 39.5233"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SlackBot;
